import React from "react"
import styles from "./styles.scss"
import CaseStudy from "components/CaseStudy"
import CaseStudyProvider from "components/CaseStudyProvider"
import colors from "images/l2e-colors.png"
import fonts from "images/l2e-fonts.png"

class Learn2EsportCaseStudy extends React.Component {
  render() {
    return (
      <CaseStudyProvider
        render={caseStudies => {
          const caseStudy = caseStudies.find(x => x.company === "Learn2Esport")
          return (
            <CaseStudy
              caseStudy={caseStudy}
              heroBackgroundColor="#3B445C"
              heroBackgroundOpacity={0.7}
              renderCompanyLogo={() => (
                <img
                  src={caseStudy.companyLogo}
                  className={styles.companyLogo}
                  alt="SAITS logo"
                />
              )}
              renderSummary={() => (
                <React.Fragment>
                  <p>
                    Learn2Esport är en helhetslösning för skolor som vill starta
                    en esportprofil. Den används just nu på fyra skolor i
                    Sverige. Learn2Esport är vår egen produkt och den centrala
                    delen är den plattform vi utvecklat.
                  </p>
                  <p>
                    Denna plattform är en utbildningsplattform fylld med
                    material som tagits fram av spelare och coacher med upp till
                    15 års erfarenhet inom esport, interaktiva prov, uppgifter
                    och fler användbara funktioner och verktyg. Skolan ska
                    enkelt kunna starta en esportprofil av hög kvalitet till ett
                    bra pris utan att ha förkunskap om esport.
                  </p>
                </React.Fragment>
              )}
              renderProblem={() => (
                <p>
                  Intresset för esport i Sverige har växt enormt de senaste
                  åren, vilket gjort att fler skolor vill erbjuda denna
                  inriktning till sina elever. Majoriteten av alla skolor som
                  startat esportinriktningar har inte haft den förkunskap som
                  krävs. När det saknas relevant material och rätt verktyg blir
                  det självklart svårt att bedriva utbildningen.
                </p>
              )}
              renderDesign={() => (
                <React.Fragment>
                  <p>
                    Vi har gedigen erfarenhet inom esport och har bland annat
                    utvecklat Keita Gaming’s plattform, en turneringsplattform
                    för onlineturneringar inom diverse esporter. Inför detta
                    projekt började vi med att analysera marknaden samt
                    målgruppen: skolor och esportintresserade elever.
                  </p>
                  <p>
                    Nästa steg var en analys som inkluderade både intervjuer och
                    undersökningar för att få veta vilka behov lärare och elever
                    hade. Vi kollade även på styrkor och svagheter hos
                    existerande lärplattformar och tog med oss denna information
                    i det vidare arbetet.
                  </p>
                  <p>
                    Learn2Esport används både av lärare och elever. Vi har dock
                    inte endast fokuserat på att göra plattformen bra för
                    elever, utan vi har även lagt arbete och kraft på att göra
                    användarupplevelsen bra för lärarna. Detta har vi
                    åstadkommit genom att inkludera välplacerade menyer samt
                    knappar som uppmanar lärare till handling.
                  </p>
                  <p>
                    Den grafiska profilen blev en utmaning i och med att skola
                    och esport ofta tar sig helt olika uttryck. Genom kreativa
                    designprocesser och brainstormingsessioner hittade vi en
                    lösning som tilltalar så väl elever som lärare. Vi har även
                    sett till båda dessa perspektiv när det gäller
                    användarvänlighet, till exempel genom välplacerade menyer
                    och knappar som uppmanar till handling.
                  </p>
                  <h3>Färger</h3>
                  <div>
                    <img
                      className={styles.colorsImage}
                      src={colors}
                      alt="Färger som används i plattformens design."
                    />
                  </div>
                  <h3>Typsnitt - Lato</h3>
                  <div className={styles.fontContainer}>
                    <p className={styles.text}>
                      Eftersom att Learn2Esport är en läroplattform där lärare
                      och elever inte sällan läser och skriver längre texter så
                      var det viktigt för oss att välja ett lättläst typstnitt.
                      Vi valde därför att använda typsnittet Lato då det är lätt
                      att läsa och samtidigt visuellt tilltalande.
                    </p>
                    <div className={styles.imageContainer}>
                      <img
                        className={styles.fontImage}
                        src={fonts}
                        alt="Olika vikter och typer av plattformens typsnitt, Lato."
                      />
                    </div>
                  </div>
                </React.Fragment>
              )}
              renderTechnology={() => (
                <React.Fragment>
                  <h3>Front end / Back end / Hosting</h3>
                  <p>
                    Plattformens back end är skrivet i webbramverket Ruby on
                    Rails, som bland annat används av stora företag som Github
                    och AirBnB. Anledningen till att vi valt Ruby on Rails är
                    att det är väldigt skalbart, vilket passar den utvecklingen
                    som plattformen kommer att ha.
                  </p>
                  <p>
                    Plattformen hostas hos cloud-plattformen Heroku (PaaS) där
                    vi kan bygga, driva och skala plattformen på ett väldigt
                    smidigt och effektivt sätt. Just dynamisk ökning/minskning
                    av serverkraft är något som Heroku erbjuder och är något som
                    vi har bra användning av när användarantalet på plattformen
                    stiger.
                  </p>
                  <p>
                    Front-end är huvudsakligen serverrenderad HTML och Sass. De
                    mer komplexa vyerna är gjorda med hjälp av React på grund av
                    att det är kraftigare och lättare att vara produktiv när det
                    kommer till komplexa lösningar.
                  </p>
                  <h3>Schemalagda jobb</h3>
                  <p>
                    Flera funktioner på plattformen baseras på att logik körs på
                    bestämda tidpunkter varje timme/dag/vecka, därför är det
                    väldigt viktigt för oss att använda oss av schemalagda jobb.
                    Ett exempel på detta är lektionstilldelningen som sker varje
                    måndag och som ger eleverna nya lektioner för veckan.
                  </p>
                  <h3>Externa API:er</h3>
                  <p>
                    För att till exempel kunna föra statistik på sidan och
                    analysera utvecklingen hos elever hämtar vi data från
                    externa API:er. Det resulterade i ett Open Source-bibliotek
                    för integration mot ett av de externa API:erna.
                  </p>
                  <h3>Hantering av organisationer</h3>
                  <p>
                    Varje organisation som använder plattformen får enbart se
                    och hantera data som tillhör den organisationen. Ett
                    alternativ för att åstadkomma detta skulle vara att varje
                    organisation får en egen “installation” och databas som bara
                    håller deras information. Vi har istället valt att göra en
                    centraliserad databas med all information, detta för att
                    vara så skalbara som möjligt. Målet med tekniken är att det
                    ska vara lika enkelt att underhålla 5 som 5 000
                    organisationer. För att skilja organisationerna åt använder
                    vi oss av subdomäner, detta gör även att vi kan skapa unika
                    domäner för de som önskar detta.
                  </p>
                </React.Fragment>
              )}
            />
          )
        }}
      />
    )
  }
}

export default Learn2EsportCaseStudy



// WEBPACK FOOTER //
// ./src/pages/CaseStudies/Learn2EsportCaseStudy/index.jsx